import { render } from "./afterLogin.vue?vue&type=template&id=22f714de&scoped=true"
import script from "./afterLogin.vue?vue&type=script&lang=js"
export * from "./afterLogin.vue?vue&type=script&lang=js"

import "./afterLogin.vue?vue&type=style&index=0&id=22f714de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f714de"]])

export default __exports__